export default "__VITE_ASSET__d0YipMEN__"